import React from "react";

import { AbstractField, AbstractFieldProps } from "./AbstractField";

export interface NumberFieldProps extends Omit<AbstractFieldProps, "type" | "render" | "children"> {}

export const NumberField: React.FC<NumberFieldProps> = ({ ...fieldProps }) => (
  <AbstractField type="number" {...fieldProps} />
);
